import { useForm } from "@/composable/form/form"
import Message from "@/const/Message"
import { DialogService } from "@/service/DialogService"
import { AxiosError } from "axios"

export class FormUtil {

  /**
   * 数値か判断します
   * @param num 
   * @returns 
   */
  public static isNumeric(num: string | number): boolean {
    if (typeof num === 'string') {
      try {
        return Number.isFinite(Number(num))
      } catch (e) {
        return false
      }
    } else {
      return Number.isFinite(num)
    }
  }

  /**
   * 整数か判断します
   * @param num 
   * @returns 
   */
  public static isInteger(num: string | number): boolean {
    if (typeof num === 'string') {
      try {
        return Number.isInteger(Number(num))
      } catch (e) {
        return false
      }
    } else {
      return Number.isInteger(num)
    }
  }

  /**
   * 半角英数のみかチェックします
   * @param str 
   * @returns 
   */
  public static isAlnum(str: string): boolean {
    return str.match(/^[0-9a-zA-Z]+$/) !== null
  }

  /**
   * 指定された桁数以内か判断します
   * @param val 
   * @param max 
   * @returns 
   */
  public static max(val: string | number, max: number): boolean {
    if (typeof val === 'string') {
      return val.length <= max
    } else {
      return val <= max
    }
  }

  /**
   * 指定された桁数以上か判断します
   * @param val 
   * @param min 
   * @returns 
   */
  public static min(val: string | number, min: number): boolean {
    if (typeof val === 'string') {
      return val.toString().length >= min
    } else {
      return val >= min
    }
  }

  /**
   * 整数型の確認と桁数の判断をします
   * @param val 
   * @param max 
   * @param min 
   * @returns 
   */
  public static isIntegerAndRangeLength(
    val: string | number,
    max: number | null = null,
    min: number | null = null
  ): boolean {
    let range = ''
    if (max && min) {
      // 最大数と最小数の両方あり
      range = `{${min},${max}}`
    } else if (max && !min) {
      // 最大数あり最小数なし
      range = `{0,${max}}`
    } else if (!max && min) {
      // 最大数なし最小数あり
      range = `{${min},}`
    }
    const reg = new RegExp(`^[0-9]${range}$`)
    return reg.test(val.toString())
  }

  /**
   * Laravelが吐き出し422エラーの形式をVue用にエラー保存箇所に値を設定します
   * @param form 
   * @param err 
   */
  public static setLaravelError(form: any, err: AxiosError<any>): void {
    if (err.response) {
      if (err.response.status === 422) {
        const { setError } = useForm()
        const errors = err.response.data.errors
        // キーを取得する
        const keys = Object.keys(errors)
        for (let idx = 0; idx < keys.length; idx++) {
          // 「.」で連結されているので分解する
          const k = keys[idx].split('.')
          if (k.length > 0) {
            // 分解した最後を配列から切り抜く
            const p = k.pop()
            if (p) {
              // 残りの部分までの階層分をたどる
              let row = form
              for (let idx2 = 0; idx2 < k.length; idx2++) {
                row = row[k[idx2]]
              }
              // 最終地点にエラーを設定する
              setError(row, p, errors[keys[idx]])
            }
          }
        }
        // ダイアログを表示
        DialogService.error({
          text: Message.ERROR_INPUT
        }, true)
      }
    }
  }

  public static createOptionArray(items: any[], optionKeys: CreateOptionKeys, defaultOption: OptionValue | null = null): OptionValue[] {
    const retOption: OptionValue[] = [];
    if (defaultOption) {
      retOption.push({
        label: defaultOption.label,
        val: defaultOption.val
      })
    }

    items.forEach(item => {
      if (optionKeys.valueKey !== null) {
        retOption.push({
          label: item[optionKeys.labelKey] ? item[optionKeys.labelKey] : '',
          val: item[optionKeys.valueKey] ? item[optionKeys.valueKey] : ''
        })
      } else {
        retOption.push({
          label: item[optionKeys.labelKey] ? item[optionKeys.labelKey] : '',
          val: item
        })
      }
    })

    return retOption;
  }
}

export interface OptionValue {
  label: string,
  val: any
}

export interface CreateOptionKeys {
  labelKey: string,
  valueKey: string | null
}